import { Icon20Stars } from '@vkontakte/icons';
import { Title } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { renderFullScreenAiPhotoGeneration } from 'reactApp/ui/AiPhotoGeneration/Screen/FullScreenAiPhotoGeneration';
import { sendXray } from 'reactApp/utils/ga';

import styles from './AiImageGenerationEntryButton.css';

interface Props {
    className?: string;
}

const AiImageGenerationEntryButton = memo(({ className }: Props) => {
    const storage = useSelector(getCurrentStorage);

    const handleClick = useCallback(() => {
        sendXray(['ai-gen', 'ep', 'click', storage]);

        renderFullScreenAiPhotoGeneration({
            onShow: () => {
                sendXray(['ai-gen', 'open', storage]);
            },
            onClose: () => {
                sendXray(['ai-gen', 'close', storage]);
            },
        });
    }, [storage]);

    useEffect(() => {
        sendXray(['ai-gen', 'ep', 'show', storage]);
    }, [storage]);

    return (
        <div className={className}>
            <div className={styles.button} onClick={handleClick}>
                <Icon20Stars width={20} height={20} color="var(--vkui--color_text_contrast)" />
                <Title level="3" className={styles.text}>
                    Сгенерировать изображение
                </Title>
            </div>
        </div>
    );
});

AiImageGenerationEntryButton.displayName = 'AiImageGenerationEntryButton';

export default AiImageGenerationEntryButton;
